export enum TcddWagonTitle {
  SKA1 = 'ska1',
  OA1 = 'oa1',
  OA1_1 = 'oa1_1',
  OA4 = 'oa4',
  OA1_2 = 'oa1_2',
  OA2 = 'oa2',
  OA3 = 'oa3',
  SKA2 = 'ska2'
}
